export default "__VITE_ASSET__CrK5XCIq__"